import { AppName } from '../utils/Constants';
import { NativePlatform } from './Constants';
import { setupAML, setupSentry, setupAccountConfig } from './sdk';

/**writing SDK setup calls in different module so that they can be mocked otherwise
importing and initializing them in same function makes it difficult. **/

async function configureWindows(initData: any): Promise<void> {
	if (initData.sentry) {
		await import(/* webpackChunkName: "sentry" */ '../sentryLogging/main');
		setupSentry(initData.sentry);
	}

	if (initData.aml) {
		await import(/* webpackChunkName: "aml" */ '../auth/main');
		initData.aml.hostApp = AppName.WORKSPACE;
		await setupAML(initData.aml);
	}

	if (initData.accountConfig) {
		initData.accountConfig.platform = NativePlatform.Windows;
		await import(/* webpackChunkName: "accountConfig" */ '../AccountConfig/index');
		await setupAccountConfig(initData.accountConfig);
	}
}

async function configureMac(initData: any): Promise<void> {
	if (initData.accountConfig) {
		await import(/* webpackChunkName: "accountConfig" */ '../AccountConfig/index');
		initData.accountConfig.platform = NativePlatform.Mac;
		await setupAccountConfig(initData.accountConfig);
	}
}

async function configureIOS(initData: any): Promise<void> {
	if (initData.accountConfig) {
		await import(/* webpackChunkName: "accountConfig" */ '../AccountConfig/index');
		initData.accountConfig.platform = NativePlatform.iOS;
		initData.accountConfig.hostApp = AppName.WORKSPACE;
		await setupAccountConfig(initData.accountConfig);
	}
}

async function configureLinux(initData: any): Promise<void> {
	if (initData.aml) {
		await import(/* webpackChunkName: "aml" */ '../auth/main');
		initData.aml.hostApp = AppName.WORKSPACE;
		await setupAML(initData.aml);
	}

	if (initData.accountConfig) {
		await import(/* webpackChunkName: "accountConfig" */ '../AccountConfig/index');
		initData.accountConfig.platform = NativePlatform.Linux;
		await setupAccountConfig(initData.accountConfig);
	}
}

async function configureCEB(initData: any): Promise<void> {
	if (initData.sentry) {
		await import(/* webpackChunkName: "sentry" */ '../sentryLogging/main');
		setupSentry(initData.sentry);
	}

	if (initData.aml) {
		await import(/* webpackChunkName: "aml" */ '../auth/main');
		initData.aml.hostApp = AppName.CITRIXBROWSER;
		await setupAML(initData.aml);
	}

	if (initData.accountConfig) {
		await import(/* webpackChunkName: "accountConfig" */ '../AccountConfig/index');
		initData.accountConfig.hostApp = AppName.CITRIXBROWSER;
		await setupAccountConfig(initData.accountConfig);
	}
}

export interface SetupWorkspaceParams {
	platform?: NativePlatform;
	hostApp?: AppName;
	initData: string;
}

export async function setupWorkspace({
	platform,
	hostApp,
	initData,
}: SetupWorkspaceParams): Promise<void> {
	const initDataJson = JSON.parse(decodeURIComponent(initData));
	if (hostApp === AppName.CITRIXBROWSER) {
		await configureCEB(initDataJson);
	} else {
		switch (platform) {
			case NativePlatform.Linux:
				await configureLinux(initDataJson);
				break;
			case NativePlatform.Mac:
				await configureMac(initDataJson);
				break;
			case NativePlatform.Windows:
				await configureWindows(initDataJson);
				break;
			case NativePlatform.iOS:
				await configureIOS(initDataJson);
				break;
		}
	}
}
